// Need to use the React-specific entry point to import createApi
import {apiSlice} from './apiSlice';

export const caseApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCases: builder.query({
      query: filter => {
        const qs = new URLSearchParams(filter).toString();
        return 'case' + (qs ? '?' + qs : '');
      },
      providesTags: ['Case', 'Patient', 'Provider', 'PayerPlan', 'Payer'],
    }),
    createCase: builder.mutation({
      query: body => ({
        url: 'case/',
        method: 'POST',
        body
      }),
      invalidatesTags: ['Case', 'Session', 'Patient'],
    }),
    updateCase: builder.mutation({
      query: ({id, body}) => ({
        url: `case/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Case', 'Session', 'Patient'],
    }),
    attachSession: builder.mutation({
      query: ({session_id}) => ({
        url: 'case_attachment/',
        method: 'POST',
        body: {session_id},
      }),
      invalidatesTags: ['Case', 'Session', 'Patient'],
    }),
    detachSession: builder.mutation({
      query: ({session_id}) => ({
        url: 'case_attachment/',
        method: 'DELETE',
        body: {session_id},
      }),
      invalidatesTags: ['Case', 'Session', 'Patient'],
    })
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetCasesQuery,
  useCreateCaseMutation,
  useUpdateCaseMutation,
  // useRemoveCaseMutation,
} = caseApi;
